import { Dispatch, SetStateAction, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { cloneForm as cloneFormService } from '../../../services/form/FormService';
import { CultureTextModel } from '../../../models/form/form';

interface Values {
  isLoading: boolean;
  cloneForm: (formId: string, newName: CultureTextModel[] | string) => void;
  setOrganizationId: Dispatch<SetStateAction<string>>;
}

const useCloneForm = (organizationId: string): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [id, setOrganizationId] = useState<string>(organizationId);

  const cloneForm = async (formId: string, newName: CultureTextModel[] | string) => {
    try {
      setIsLoading(true);
      const newForm = { id: id, name: newName };

      const result = await cloneFormService(organizationId, formId, newForm);
      setIsLoading(false);
      return result;
    } catch (error) {
      handleError(error);
      setIsLoading(false);
    }
  };

  return { cloneForm, isLoading, setOrganizationId };
};

export default useCloneForm;
